import React from "react";
import {SVG} from "assets/svg";

const Icon = ({name, ...props}) => {
    const Icon = SVG[name];
    return <Icon {...props} />;
};

export default Icon;